import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jobCardConfig: {
        isLoading: false,
        data: null,
        jobCardConfigError: ''
    },
    jobSearchParams: {
        searchVehicleIds: '',
        searchJobStatus: '',
        searchBranchIds: '',
        showJobCardFilter: false,
        jobCardFilter: { jobCardFromDate: '', jobCardToDate: '', jobCardNo: '', driverIds: '' }
    },
    jobCards: {
        isLoading: false,
        isLoadingMore: false,
        data: null,
        selectedJobCard: null,
        showJobCardForm: false,
        jobCardFormEditMode: false,
        jobCardError: '',
        jobCardLoadMoreError: ''
    },
    jobCardTasks: {
        isLoading: false,
        data: null,
        selectedTask: null,
        showTaskForm: false,
        taskFormEditMode: false,
        taskError: '',
        totalTaskAmount: 0,
    },
    jobCardInventory: {
        isLoading: false,
        data: null,
        selectedInventory: null,
        showInventoryForm: false,
        inventoryFormEditMode: false,
        inventoryError: ''
    },
    jobCardActivityLog: {
        setOpen: 1,
    }
}

const jobCardSlice = createSlice({
    name: "jobCard",
    initialState,
    reducers: {
        jobCardConfigPending: (state) => {
            state.jobCardConfig.isLoading = true;
        },
        jobCardConfigLoadingSuccess: (state, { payload }) => {
            state.jobCardConfig.isLoading = false;
            state.jobCardConfig.data = payload;
            state.jobCardConfig.jobCardConfigError = '';
        },
        jobCardConfigLoadingFailed: (state, { payload }) => {
            state.jobCardConfig.isLoading = false;
            state.jobCardConfig.jobCardConfigError = payload;
        },
        jobCardSearchParamsUpdates: (state, { payload }) => {
            if (payload.searchVehicleIds) {
                state.jobSearchParams.searchVehicleIds = payload.searchVehicleIds;
            } else if (payload.searchVehicleIds === '') {
                state.jobSearchParams.searchVehicleIds = '';
            }
            if (payload.searchJobStatus) {
                state.jobSearchParams.searchJobStatus = payload.searchJobStatus;
            } else if (payload.searchJobStatus === '') {
                state.jobSearchParams.searchJobStatus = '';
            }
            if (payload.searchBranchIds) {
                state.jobSearchParams.searchBranchIds = payload.searchBranchIds;
            } else if (payload.searchBranchIds === '') {
                state.jobSearchParams.searchBranchIds = '';
            }
        },
        jobCardFilterToggle: (state, { payload }) => {
            state.jobSearchParams.showJobCardFilter = payload
        },
        jobCardFilterParamsUpdates: (state, { payload }) => {
            state.jobSearchParams.jobCardFilter = { ...state.jobSearchParams.jobCardFilter, ...payload };
        },
        jobCardLoadingPending: (state) => {
            state.jobCards.isLoading = true;
        },
        jobCardLoadingSuccess: (state, { payload }) => {
            state.jobCards.isLoading = false;
            state.jobCards.data = payload;
            state.jobCards.selectedJobCard = payload[0] || null;
            state.jobCards.jobCardError = '';
        },
        jobCardLoadingFailed: (state, { payload }) => {
            state.jobCards.isLoading = false;
            state.jobCards.data = []
            state.jobCards.jobCardError = payload;
        },
        jobCardFormFailed: (state, { payload }) => {
            state.jobCards.jobCardError = payload;
        },
        jobCardLoadMorePending: (state) => {
            state.jobCards.isLoadingMore = true;
        },
        jobCardLoadMoreSuccess: (state, { payload }) => {
            state.jobCards.isLoadingMore = false;
            // state.jobCards.data = state.jobCards.data.concat(payload);
            state.jobCards.data = payload;
            state.jobCards.jobCardLoadMoreError = '';
        },
        jobCardLoadMoreFailed: (state, { payload }) => {
            state.jobCards.isLoadingMore = false;
            state.jobCards.jobCardLoadMoreError = payload;
        },
        jobCardDataUpdate: (state, { payload }) => {
            state.jobCards.data = payload;
        },
        selectJobCard: (state, { payload }) => {
            const selectedJobCard = state.jobCards.data.find((jc) => jc.jobCardId === payload);
            if (selectedJobCard) {
                state.jobCards.selectedJobCard = selectedJobCard;
            }
        },
        showJobCardForm: (state, { payload }) => {
            state.jobCards.showJobCardForm = true;
            state.jobCards.jobCardFormEditMode = payload ? payload : false;
        },
        hideJobCardForm: (state) => {
            state.jobCards.showJobCardForm = false;
            state.jobCards.jobCardFormEditMode = false;
        },
        jobCardTaskLoadingPending: (state) => {
            state.jobCardTasks.isLoading = true;
        },
        jobCardTasklLoadingSuccess: (state, { payload }) => {
            state.jobCardTasks.isLoading = false;
            state.jobCardTasks.data = payload;
            if (payload.length > 0) {
                const oldSelectedTask = state.jobCardTasks.selectedTask;
                let newSelectedTask = payload[0];
                if (oldSelectedTask) {
                    newSelectedTask = payload.find((inv) => inv.jobCardTaskId === oldSelectedTask.jobCardTaskId) || payload[0] || null;
                }
                state.jobCardTasks.selectedTask = newSelectedTask;
            } else {
                state.jobCardTasks.selectedTask = null;
                state.jobCardInventory.data = [];
                state.jobCardInventory.selectedInventory = null;
            }
            state.jobCardTasks.taskError = '';
        },
        jobCardTaskLoadingFailed: (state, { payload }) => {
            state.jobCardTasks.isLoading = false;
            state.jobCardTasks.data = [];
            state.jobCardTasks.taskError = payload;
        },
        selectJobCardTask: (state, { payload }) => {
            const selectedJobCardTask = state.jobCardTasks.data.find((jc) => jc.jobCardTaskId === payload);
            if (selectedJobCardTask) {
                state.jobCardTasks.selectedTask = selectedJobCardTask;
            }
        },
        setJobCardTaskAmount: (state, { payload }) => {
            if (payload) {
                state.jobCardTasks.totalTaskAmount = payload.totalTaskAmount;
            }
        },
        showJobCardTaskForm: (state, { payload }) => {
            state.jobCardTasks.showTaskForm = true;
            state.jobCardTasks.taskFormEditMode = payload ? payload : false;
        },
        hideJobCardTaskForm: (state) => {
            state.jobCardTasks.showTaskForm = false;
            state.jobCardTasks.taskFormEditMode = false;
        },
        jobCardInventoryLoadingPending: (state) => {
            state.jobCardInventory.isLoading = true;
        },
        jobCardInventoryLoadingSuccess: (state, { payload }) => {
            state.jobCardInventory.isLoading = false;
            state.jobCardInventory.data = payload;
            if (payload.length > 0) {
                const oldSelectedInventory = state.jobCardInventory.selectedInventory;
                let newSelectedInvetory = payload[0];
                if (oldSelectedInventory) {
                    newSelectedInvetory = payload.find((inv) => inv.jobCardInvId === oldSelectedInventory.jobCardInvId) || payload[0] || null;
                }
                state.jobCardInventory.selectedInventory = newSelectedInvetory;
            } else {
                state.jobCardInventory.selectedInventory = null;
            }
            state.jobCardInventory.inventoryError = '';
        },
        jobCardInventoryLoadingFailed: (state, { payload }) => {
            state.jobCardInventory.isLoading = false;
            state.jobCardInventory.data = [];
            state.jobCardInventory.inventoryError = payload;
        },
        showJobCardInventoryForm: (state, { payload }) => {
            state.jobCardInventory.showInventoryForm = true;
            state.jobCardInventory.inventoryFormEditMode = payload ? payload : false;
            state.jobCardInventory.inventoryError = '';
        },
        hideJobCardInventoryForm: (state) => {
            state.jobCardInventory.showInventoryForm = false;
            state.jobCardInventory.inventoryFormEditMode = false;
        },
        selectJobCardInventory: (state, { payload }) => {
            const selectedJobCardInventory = state.jobCardInventory.data.find((jc) => jc.jobCardInvId === payload);
            if (selectedJobCardInventory) {
                state.jobCardInventory.selectedInventory = selectedJobCardInventory;
            }
        },
        setJobCardActivityLog: (state, { payload }) => {
            state.jobCardActivityLog.setOpen = payload;
        }
    }
});


const { reducer, actions } = jobCardSlice;

export const {
    jobCardConfigPending, jobCardConfigLoadingSuccess, jobCardConfigLoadingFailed, jobCardSearchParamsUpdates, jobCardFilterToggle, jobCardFilterParamsUpdates,
    jobCardLoadingPending, jobCardLoadingSuccess, jobCardLoadingFailed, jobCardDataUpdate, selectJobCard, showJobCardForm, hideJobCardForm, jobCardFormFailed,
    jobCardLoadMorePending, jobCardLoadMoreSuccess, jobCardLoadMoreFailed,
    jobCardTaskLoadingPending, jobCardTasklLoadingSuccess, jobCardTaskLoadingFailed, selectJobCardTask, showJobCardTaskForm, hideJobCardTaskForm, setJobCardTaskAmount,
    jobCardInventoryLoadingPending, jobCardInventoryLoadingSuccess, jobCardInventoryLoadingFailed, showJobCardInventoryForm, hideJobCardInventoryForm, selectJobCardInventory, setJobCardActivityLog
} = actions;

export default reducer;